import { Divider } from "@nextui-org/react";
import * as React from "react";
import { useStaffDetails } from "./useStaffDetails";
import { SectionHeader } from "app/components/sectionHeader";
import { InputEdit } from "app/components/inputEdit/InputEdit";
import Select from "react-select";
import { EmployeesSliceState } from "app/redux/employeesSlice";
import { titleize } from "app/utils/string";
import { CameraIcon } from "@heroicons/react/24/solid";
import { Avatar } from "app/components/avatar/avatar";
import { format } from "date-fns";
import { AsIconButton, reactSelectStyles } from "app/subframe";
import { Upload, User } from "lucide-react";
import { useRef } from "react";
import { useStaff } from "../useStaff";
import { AsButton } from "app/subframe";

export interface StaffDetailsProps {
  selectedEmployee: EmployeesSliceState;
  onResendInvite: any
}

export const StaffDetails: React.FC<StaffDetailsProps> = ({
  selectedEmployee,
  onResendInvite
}) => {
  const {
    onEmployeeUpdate,
    handleShopSelectionChange,
    existingShops,
    employeeShops,
    handleAvatarChange,
    onDisableEmployee,
    onReenableEmployee,
    onImpersonate,
  } = useStaffDetails({
    selectedEmployee,
  });





  const disabled = selectedEmployee?.invitePending;

  const fileInputRef = useRef<any>(null);
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="flex flex-col gap-6">
      {/*<SectionHeader title="Staff Details" />*/}
      <div className="space-y-6">
        <div className="flex items-center space-x-6">

          <div className="flex flex-col items-center">
            <div
              className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-2">
              <label className="relative cursor-pointer">
                <Avatar
                  name={selectedEmployee?.name}
                  src={selectedEmployee?.avatar}
                  size={56}
                />
                <input
                  ref={fileInputRef}
                  type="file"
                  className="hidden"
                  onChange={handleAvatarChange} // Call this function when a file is selected
                  accept="image/*"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 hover:opacity-100 rounded">
                  <CameraIcon className="h-6 w-6 text-white" />
                </div>

              </label>
            </div>
            <button
              onClick={handleUploadClick}
              className="text-sm text-blue-600 hover:text-blue-700 flex items-center space-x-1">
              <Upload className="w-3 h-3" />
              <span>Upload Photo</span>
            </button>
            <AsButton
              variant="neutral-secondary"
              onClick={onImpersonate}
              className="mt-4"
              size="sm"
              text="Login As Staff"
            />

          </div>

          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label
                className="block text-sm font-medium text-gray-700 mb-2">Bio</label>
              <div className="w-full">
                <div className="flex items-center gap-2">
                  <InputEdit
                    placeholder={'Bio'}
                    defaultValue={selectedEmployee?.bio}
                    onSave={onEmployeeUpdate}
                    name="bio"
                    containerClassName="w-full"
                  />
                </div>

              </div>


            </div>

            <div>
              <label
                className="block text-sm font-medium text-gray-700 mb-2">Name</label>
              {/*<input*/}
              {/*    type="text"*/}
              {/*    value={selectedEmployee.name}*/}
              {/*    onChange={(e) => setSelectedStaff(prev => prev ? {*/}
              {/*      ...prev, name: e.target.value*/}
              {/*    } : null)}*/}
              {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
              {/*/>*/}

              <div className="w-full">
                <div className="flex items-center gap-2">
                  <InputEdit
                    defaultValue={selectedEmployee?.name}
                    onSave={onEmployeeUpdate}
                    name="name"
                    containerClassName="w-full"
                  />
                </div>

              </div>


            </div>
            <div>
              <label
                className="block text-sm font-medium text-gray-700 mb-2">Role</label>
              {/*<input*/}
              {/*    type="text"*/}
              {/*    value={selectedEmployee.role}*/}
              {/*    onChange={(e) => setSelectedStaff(prev => prev ? {*/}
              {/*      ...prev, role: e.target.value*/}
              {/*    } : null)}*/}
              {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
              {/*/>*/}

              <Select
                key={`select-${selectedEmployee.id}-${selectedEmployee.role}`} // Use key to force re-render
                defaultValue={
                  {
                    value: selectedEmployee.role,
                    label: titleize(selectedEmployee.role),
                  } as any
                }
                styles={{
                  ...reactSelectStyles({
                    borderContainer: true,
                  }),
                }}
                className="text-sm"
                onChange={({ value }) => onEmployeeUpdate({ role: value })}
                options={[
                  { value: "admin", label: "Admin" },
                  { value: "employee", label: "Employee" },
                ]}
              />



            </div>
            <div>
              <label
                className="block text-sm font-medium text-gray-700 mb-2">Email</label>
              {/*<input*/}
              {/*    type="email"*/}
              {/*    value={selectedEmployee.email}*/}
              {/*    onChange={(e) => setSelectedStaff(prev => prev ? {*/}
              {/*      ...prev, email: e.target.value*/}
              {/*    } : null)}*/}
              {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
              {/*/>*/}
              <InputEdit
                valueClassName="text-zinc-700 text-base font-semibold leading-normal"
                defaultValue={selectedEmployee?.email}

                name="email"
                type="email"
                onSave={onEmployeeUpdate}
              />

            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Phone
              </label>
              {/*<input*/}
              {/*    type="tel"*/}
              {/*    value={selectedEmployee.phone}*/}
              {/*    onChange={(e) => setSelectedStaff(prev => prev ? {*/}
              {/*      ...prev, phone: e.target.value*/}
              {/*    } : null)}*/}
              {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
              {/*/>*/}

              <InputEdit
                valueClassName="text-zinc-700 text-base font-semibold leading-normal"
                defaultValue={selectedEmployee?.phone}
                name="phone"
                type="phone"
                onSave={onEmployeeUpdate}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Employee Code
              </label>
              <InputEdit
                valueClassName="text-zinc-700 text-base font-semibold leading-normal"
                defaultValue={selectedEmployee?.invitationToken}
                name="invitationToken"
                placeholder="Enter Employee Code"
                maxLength={5}
                isNumeric={true}
                onSave={onEmployeeUpdate}
              />
            </div>
          </div>
        </div>

        {/*<div className={'py-4'}>*/}
        {/*  <label*/}
        {/*      className="block text-sm font-medium text-gray-700 mb-2">Status</label>*/}
        {/*  <select*/}
        {/*      value={'Active'}*/}
        {/*      // onChange={(e) => setSelectedStaff(prev => prev ? {*/}
        {/*      //   ...prev, status: e.target.value as 'active' | 'inactive'*/}
        {/*      // } : null)}*/}
        {/*      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent max-w-xs"*/}
        {/*  >*/}
        {/*    <option value="active">Active</option>*/}
        {/*    <option value="inactive">Inactive</option>*/}
        {/*  </select>*/}
        {/*</div>*/}
      </div>
    </div>
  );
};
